import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogContentWithCards } from "../components/DialogContent";
import { DialogTitle } from "../components/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { TextInput } from "../components/TextInput";
import { Chips } from "../components/Chips";
import { PaperCard } from "../components/PaperCard";
import { SelectInput } from "../components/SelectInput";
import SelectOrganization from "../containers/SelectOrganization";
import SelectableTable from "../components/SelectableTable";

export const AddDeviceGroupDialog = ({
  onClose,
  onSave,
  allAppBundles,
  selectedBundleKeys,
  onBundleSelect,
  name,
  registrationCode,
  nameNotUnique,
  registrationCodeNotUnique,
  saveAvaliable,
  onNameChange,
  onRegistrationCodeChange,
  kioskAppKey,
  kioskAppOptions,
  onKioskAppChange,
  organizationKey,
  onOrganizationChange,
  allApps: { managedApps, externalApps },
  selectedApps,
  appsApprovedByBundles,
  onAppSelect  
}) => {
  const headers = ["Approved", "", "Title", "Package Name", "VR Type(s)"];
  return (
    <Dialog maxWidth="lg" scroll="body" onClose={onClose} open>
      <DialogTitle
        onCancel={onClose}
        onSave={onSave}
        saveAvaliable={saveAvaliable}
        darkBg
      >
        New Device Group
      </DialogTitle>
      <DialogContentWithCards>
        <Typography variant="caption">*Required Inputs</Typography>

        <Grid container spacing={3}>
          <Grid item xs={6}>
            <PaperCard>
              <TextInput
                label={nameNotUnique ? "Must be unique" : "Name"}
                value={name}
                error={nameNotUnique}
                onChange={onNameChange}
                required
              />
              <TextInput
                label={
                  registrationCodeNotUnique
                    ? "Must be unique"
                    : "Registration Code"
                }
                value={registrationCode}
                error={registrationCodeNotUnique}
                onChange={onRegistrationCodeChange}
                required
              />
              <br />
              <br />
              <Chips
                data={allAppBundles}
                onChange={onBundleSelect}
                selectedValue={selectedBundleKeys}
                title="App Bundles"
              />
              <br />
              <br />
              <SelectInput
                label="Kiosk App"
                value={kioskAppKey}
                options={kioskAppOptions}
                onChange={onKioskAppChange}
              />
              <br />
              <br />
              <SelectOrganization
                value={organizationKey}
                onChange={onOrganizationChange}
              />
            </PaperCard>
          </Grid>

          <Grid item xs={6}>
            <PaperCard>
              <Typography variant="body1">
                There are two ways to add new devices to this group:
              </Typography>
              <Typography variant="body2" component="span">
                <ol>
                  <li>Register a new device using the Registration Code.</li>
                  <li>
                    Move an existing device to this group from the Devices page.
                  </li>
                </ol>
              </Typography>
            </PaperCard>
          </Grid>

          <Grid item xs={12}>
              <PaperCard>
                <Typography variant="subtitle1">
                  <b>Managed Apps</b>
                </Typography>
                <SelectableTable
                  headers={headers}
                  rows={managedApps}
                  selected={selectedApps}
                  onSelect={onAppSelect}
                  forcedToSwitchedOn={appsApprovedByBundles}
                />
              </PaperCard>
            </Grid>

            <Grid item xs={12}>
              <PaperCard>
                <Typography variant="subtitle1">
                  <b>External Apps</b>
                </Typography>
                <SelectableTable
                  headers={headers}
                  rows={externalApps}
                  selected={selectedApps}
                  onSelect={onAppSelect}
                  forcedToSwitchedOn={appsApprovedByBundles}
                />
              </PaperCard>
            </Grid>
        </Grid>
      </DialogContentWithCards>
    </Dialog>
  );
};

